import script from "./ClientUserFileDocModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientUserFileDocModal.vue?vue&type=script&setup=true&lang=ts"

import "./ClientUserFileDocModal.vue?vue&type=style&index=0&id=2f5719d8&scoped=true&lang=scss"

import exportComponent from "/home/forge/crm.thebcr.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f5719d8"]])

export default __exports__